import { render, staticRenderFns } from "./SolicitudForm.vue?vue&type=template&id=1f821c2f&scoped=true&"
import script from "./SolicitudForm.vue?vue&type=script&lang=ts&"
export * from "./SolicitudForm.vue?vue&type=script&lang=ts&"
import style0 from "./SolicitudForm.vue?vue&type=style&index=0&id=1f821c2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f821c2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1f821c2f', component.options)
    } else {
      api.reload('1f821c2f', component.options)
    }
    module.hot.accept("./SolicitudForm.vue?vue&type=template&id=1f821c2f&scoped=true&", function () {
      api.rerender('1f821c2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Solicitudes/SolicitudForm.vue"
export default component.exports